import axios from "axios";

export const BmeShop = {
    ENDPOINT: 'https://bmeshopapi.maxgoddard.dev/v1/',
    getEndpoint: (url) => BmeShop.ENDPOINT + url + '/',
    makeRequest: (method, url, data = {}, config = {}) => new Promise((resolve, reject) => {
        axios({
            method,
            url: BmeShop.getEndpoint(url),
            data,
            headers: {
                ...(config.headers || {}),
                'Authorization': config.token ? `Bearer ${config.token}` : undefined,
            },
        }).then((res) => {
            const data = res.data;

            if (data.error) {
                reject(data);
            } else {
                resolve(data);
            }
        }).catch((err) => {
            reject({
                error: 'NETWORK_ERROR',
                message: 'Encountered a network error.',
                data: err,
            });
        });
    }),
    account: {
        login: (email, password) =>
            BmeShop.makeRequest(
                'post',
                'account/login',
                { email, password },
            ),
        logout: (token) =>
            BmeShop.makeRequest(
                'post',
                'account/logout',
                { token },
            ),
        link: {
            canvas: (canvasToken, token) =>
                BmeShop.makeRequest(
                    'post',
                    'account/link/canvas',
                    { token: canvasToken },
                    { token },
                ),
        }
    },
    user: {
        self: (token) =>
            BmeShop.makeRequest(
                'post',
                'user/self',
                {},
                { token },
            )
    },
    time: {
        period: {
            getBetween: (start, end, token) =>
                BmeShop.makeRequest(
                    'post',
                    'time/period',
                    { start: BmeShop.dateToSQL(start), end: BmeShop.dateToSQL(end) },
                    { token },
                ).then((data) => {
                    data.periods.forEach((period) => {
                        period.start = new Date(period.start + 'Z');
                        period.end = new Date(period.end + 'Z');
                    });

                    return data.periods;
                }),
            alter: (data, token) =>
                BmeShop.makeRequest(
                    'post',
                    'time/period',
                    { ...data, start: data.start ? BmeShop.dateToSQL(data.start) : undefined, end: data.end ? BmeShop.dateToSQL(data.end) : undefined },
                    { token },
                )
        },
        task: {
            getBetween: (start, end, token) =>
                BmeShop.makeRequest(
                    'post',
                    'time/task',
                    { start: BmeShop.dateToSQL(start), end: BmeShop.dateToSQL(end) },
                    { token },
                ).then((data) => {
                    data.tasks.forEach((task) => {
                        task.start = new Date(task.start + 'Z');
                        task.end = new Date(task.end + 'Z');
                    });

                    return data.tasks;
                }),
            alter: (data, token) =>
                BmeShop.makeRequest(
                    'post',
                    'time/task',
                    { ...data, start: data.start ? BmeShop.dateToSQL(data.start) : undefined, end: data.end ? BmeShop.dateToSQL(data.end) : undefined },
                    { token },
                ),
            batch: (tasks, token) =>
                BmeShop.makeRequest(
                    'post',
                    'time/task/batch',
                    tasks.map((data) => ({ ...data, start: data.start ? BmeShop.dateToSQL(data.start) : undefined, end: data.end ? BmeShop.dateToSQL(data.end) : undefined })),
                    { token },
                )
        },
        event: {
            getBetween: (start, end, token) =>
                BmeShop.makeRequest(
                    'post',
                    'time/event',
                    { start: BmeShop.dateToSQL(start), end: BmeShop.dateToSQL(end) },
                    { token },
                ).then((data) => {
                    data.events.forEach((event) => {
                        event.start = new Date(event.start + 'Z');
                        event.end = new Date(event.end + 'Z');
                    });

                    return data.events;
                }),
            alter: (data, token) =>
                BmeShop.makeRequest(
                    'post',
                    'time/event',
                    { ...data, start: data.start ? BmeShop.dateToSQL(data.start) : undefined, end: data.end ? BmeShop.dateToSQL(data.end) : undefined, recurring_end: data.recurring_end ? BmeShop.dateToSQL(data.recurring_end) : undefined },
                    { token },
                )
        },
        label: {
            list: (token) =>
                BmeShop.makeRequest(
                    'post',
                    'time/label',
                    {},
                    { token },
                ).then((data) => data.labels),
            alter: (data, token) =>
                BmeShop.makeRequest(
                    'post',
                    'time/label',
                    data,
                    { token },
                ),
        }
    },
    import: {
        canvas: (token) =>
            BmeShop.makeRequest(
                'post',
                'import/canvas',
                {},
                { token },
            )
    },
    dateToSQL: (date) => date.toISOString().slice(0, -8).replace('T', ' '),
};